// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import {
  addContactUsApi,
  deleteContactUsApi,
  getContactUsApi,
  updateContactUsApi
} from "../../../../services/Web/contactUs.service"
import { toastError, toastSuccess } from "../../../../utility/toastutill"

// ** Get All ContactUs Data
export const getAllContactUsData = createAsyncThunk(
  "contactUs/getAllContactUsData",
  async () => {
    try {
      const response = await getContactUsApi()
      if (response.data.success) {
        toastSuccess(response.data.message)
      }
      return response.data.data
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

// ** Add New ContactUs
export const addContactUs = createAsyncThunk(
  "contactUs/addContactUs",
  async (formData, { dispatch, getState }) => {
    try {
      const res = await addContactUsApi(formData)
      if (res.data) {
        toastSuccess(res.data.message)
        await dispatch(getAllContactUsData(getState().contactUs.params))
        await dispatch(getAllContactUsData())
      }
      return res.data.success ? res.data.success : false
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

// ** Update ContactUs
export const updateContactUs = createAsyncThunk(
  "contactUs/updateContactUs",
  async (formData, { dispatch, getState }) => {
    try {
      const res = await updateContactUsApi(formData.id, formData)
      if (res.data.success) {
        toastSuccess(res.data.message)
        await dispatch(getAllContactUsData(getState().contactUs.params))
        await dispatch(getAllContactUsData())
      }
      return res.data.success ? res.data.success : false
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

// ** Delete ContactUs
export const deleteContactUs = createAsyncThunk(
  "contactUs/deleteContactUs",
  async (id, { dispatch, getState }) => {
    try {
      const res = await deleteContactUsApi(id)
      if (res.data.success) {
        toastSuccess(res.data.message)
        await dispatch(getAllContactUsData(getState().contactUs.params))
        await dispatch(getAllContactUsData())
      }
      return id
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

export const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedContactUs: null,
    success: false,
    loading: false,
    error: null
  },
  reducers: {
    clearSelectedContactUs: (state) => {
      state.selectedContactUs = null
    },
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = false
    }
  },
  extraReducers: (builder) => {
    builder
      // Get All ContactUs Data
      .addCase(getAllContactUsData.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllContactUsData.fulfilled, (state, action) => {
        state.loading = false
        state.allData = action.payload
        state.data = action.payload
      })
      .addCase(getAllContactUsData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Add ContactUs
      .addCase(addContactUs.pending, (state) => {
        state.loading = true
        state.success = false
      })
      .addCase(addContactUs.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(addContactUs.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = action.payload
      })
      
      // Update ContactUs
      .addCase(updateContactUs.pending, (state) => {
        state.loading = true
        state.success = false
      })
      .addCase(updateContactUs.fulfilled, (state, action) => {
        state.loading = false
        state.selectedContactUs = null
        state.success = action.payload
      })
      .addCase(updateContactUs.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = action.payload
      })
      
      // Delete ContactUs
      .addCase(deleteContactUs.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteContactUs.fulfilled, (state, action) => {
        state.loading = false
        // Remove deleted item from state
        state.allData = state.allData.filter(item => item.id !== action.payload)
        state.data = state.data.filter(item => item.id !== action.payload)
      })
      .addCase(deleteContactUs.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearSelectedContactUs, clearError, clearSuccess } = contactUsSlice.actions

export default contactUsSlice.reducer